export default {
    title: 'Radio1.7 - najlepsze studenckie radio w Krakowie'
}
